import React, { useEffect, useRef, useState } from 'react';
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css';
import Layout from '../Layout/Layout.js';
import { APIUrl } from '../../Helper/APIUrl.js';
import { useSnackbar } from "notistack";
import { useSearchParams } from "react-router-dom";
import DataTable from 'react-data-table-component';
import { handleKeyPress } from '../../Helper/Helper.js';

const quillModules = {
    toolbar: [
        [{ font: [] }, { size: ['small', false, 'large', 'huge'] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
        [{ direction: 'rtl' }, { align: [] }],
        ['blockquote', 'code-block'],
        ['link', 'image', 'video'],
        ['clean']
    ],
    history: {
        delay: 500,
        maxStack: 100,
        userOnly: true
    },
    clipboard: {
        matchVisual: false
    }
};

const quillFormats = [
    'font',
    'size',
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'color',
    'background',
    'script',
    'list',
    'bullet',
    'indent',
    'direction',
    'align',
    'blockquote',
    'link',
    'image',
    'video',
    'code-block'
];

const MAX_EDITOR_IMAGE_SIZE_BYTES = 2 * 1024 * 1024;

const MAX_IMAGE_SIZE_BYTES = 1.5 * 1024 * 1024;
const ALLOWED_IMAGE_EXTENSIONS = /\.(jpg|jpeg|png)$/i;
const DUMMY_IMAGE_PREVIEW = 'https://dummyimage.com/200x200/f1f5f9/64748b&text=IMG';

const getPlainTextFromHtml = (html) => {
    if (!html) {
        return '';
    }

    return html.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').trim();
};

function FAQ() {

    const Token = JSON.parse(localStorage.getItem('tcn'));
    const localStorageUserId = JSON.parse(localStorage.getItem('userid'));
    const { enqueueSnackbar } = useSnackbar();

    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");

    const [ddlPageURLMaster, setddlPageURLMaster] = useState([]);

    const [edit, setEdit] = useState(false);

    const [FAQId, setFAQId] = useState(0);
    const [URLId, setURLId] = useState(0);
    const [Title, setTitle] = useState("");
    const [Description, setDescription] = useState("");
    const [Sequence, setSequence] = useState("");
    const [ImagePath, setImagePath] = useState("");
    const [ImageFile, setImageFile] = useState(null);
    const [ImageAltText, setImageAltText] = useState("");
    const [ImageTitle, setImageTitle] = useState("");
    const [ImageDescription, setImageDescription] = useState("");
    const [ImageCreatedBy, setImageCreatedBy] = useState("");
    const [YoutubeVideoURL, setYoutubeVideoURL] = useState("");
    const [IsActive, setIsActive] = useState(true);
    const [CreatedBy, setCreatedBy] = useState(localStorageUserId || 0);

    const [State, setState] = useState("");
    const [City, setCity] = useState("");
    const [PropertyTypeName, setPropertyTypeName] = useState("");
    const [PageURL, setPageURL] = useState("");
    const [ImageError, setImageError] = useState("");
    const imageInputRef = useRef(null);
    const pageURLSelectRef = useRef(null);
    const imageUploadButtonRef = useRef(null);
    const descriptionEditorRef = useRef(null);

    const [IsHadImage, setIsHadImage] = useState(false);

    const [search, setsearch] = useState('');
    const [lstFAQ, setlstFAQ] = useState([]);
    const [filterFAQ, setfilterFAQ] = useState([]);

    const TitleRef = useRef(null);
    const DescriptionRef = useRef(null);
    const SequenceRef = useRef(null);
    const ImagePathRef = useRef(null);
    const ImageFileRef = useRef(null);
    const ImageAltTextRef = useRef(null);
    const ImageTitleRef = useRef(null);
    const ImageDescriptionRef = useRef(null);
    const ImageCreatedByRef = useRef(null);
    const YoutubeVideoURLRef = useRef(null);

    const [flagAddFAQ, setFlagAddFAQ] = useState(false);

    const getImageSrc = (path) => {
        if (!path) {
            return DUMMY_IMAGE_PREVIEW;
        }

        if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:')) {
            return path;
        }

        return APIUrl.BaseUrl + path;
    };

    const coloumn = [
        {
            name: 'SNo.',
            selector: (row, index) => index + 1,
            maxWidth: '70px'
        },
        {
            name: 'Title / Description',
            selector: (row) => `${row.Title || ''} ${getPlainTextFromHtml(row.Description || '')}`,
            sortable: true,
            grow: 3,
            wrap: true,
            cell: (row) => (
                <div className="py-2">
                    <p className="text-sm font-semibold text-slate-800 break-words whitespace-normal">{row.Title}</p>
                    <p className="text-xs text-slate-600 break-words whitespace-normal mt-1">{getPlainTextFromHtml(row.Description || '')}</p>
                </div>
            )
        },
        {
            name: 'Sequence',
            selector: (row) => row.Sequence,
            sortable: true,
            grow: 1
        },
        {
            name: 'Image Details',
            selector: (row) => `${row.ImageTitle || ''} ${row.ImageAltText || ''} ${row.ImageCreatedBy || ''} ${row.ImageDescription || ''}`,
            sortable: true,
            grow: 3,
            wrap: true,
            cell: (row) => (
                <div className="flex items-start gap-3 py-2">
                    <img
                        src={getImageSrc(row.ImagePath)}
                        alt={row.ImageAltText || 'FAQ Image'}
                        className="h-12 w-16 rounded object-cover border border-slate-200 shrink-0"
                    />
                    <div className="min-w-0">
                        <p className="text-xs text-slate-700 break-words whitespace-normal"><span className="font-semibold">Alt:</span> {row.ImageAltText || '-'}</p>
                        <p className="text-xs text-slate-700 break-words whitespace-normal"><span className="font-semibold">Title:</span> {row.ImageTitle || '-'}</p>
                        <p className="text-xs text-slate-700 break-words whitespace-normal"><span className="font-semibold">By:</span> {row.ImageCreatedBy || '-'}</p>
                        <p className="text-xs text-slate-700 break-words whitespace-normal"><span className="font-semibold">Desc:</span> {row.ImageDescription || '-'}</p>
                    </div>
                </div>
            )
        },
        {
            name: 'Status',
            cell: (row) => row.IsActive
                ? <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Activated</label>
                : <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">Deactivated</label>,
            grow: 1
        },
        {
            name: 'Action',
            grow: 1,
            cell: (row) => (
                <div className="flex items-center gap-2 py-2">
                    <button
                        type="button"
                        onClick={() => handleEditFAQ(row, row?.FAQId)}
                        className="text-white bg-gradient-to-r from-sky-500 to-blue-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-sky-200 font-medium rounded-lg text-sm px-3 py-2"
                        title="Edit FAQ"
                    >
                        <i className="fa fa-pencil" aria-hidden="true"></i>
                    </button>
                    {
                        row.IsActive
                            ?
                            <button
                                type="button"
                                onClick={() => activateDeactiveFAQ(row.FAQId, 'deactivate')}
                                className="text-white bg-gradient-to-r from-green-500 to-emerald-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-200 font-medium rounded-lg text-sm px-3 py-2"
                                title="Deactivate FAQ"
                            >
                                <i className="fa fa-toggle-on" aria-hidden="true"></i>
                            </button>
                            :
                            <button
                                type="button"
                                onClick={() => activateDeactiveFAQ(row.FAQId, 'activate')}
                                className="text-white bg-gradient-to-r from-red-500 to-rose-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-200 font-medium rounded-lg text-sm px-3 py-2"
                                title="Activate FAQ"
                            >
                                <i className="fa fa-toggle-off" aria-hidden="true"></i>
                            </button>
                    }
                </div>
            )
        }
    ];

    useEffect(() => {
        getddlPageURLMaster();
        getAllFAQs();
    }, [])

    useEffect(() => {
        const query = (search || '').toLowerCase();

        const result = lstFAQ.filter((x) => {
            const searchableValues = [
                x?.Title,
                getPlainTextFromHtml(x?.Description || ''),
                x?.Sequence,
                x?.ImageAltText,
                x?.ImageTitle,
                x?.ImageCreatedBy,
                x?.ImageDescription
            ];

            return searchableValues.some((value) => String(value || '').toLowerCase().includes(query));
        });

        setfilterFAQ(result);
    }, [search, lstFAQ]);

    useEffect(() => {
        if (!id || isNaN(id) || ddlPageURLMaster.length === 0) {
            return;
        }

        handleDDLChange(id);
    }, [id, ddlPageURLMaster]);

    // Safe JSON parse helper to avoid "Unexpected end of JSON input"
    const parseJSON = async (response) => {
        try {
            const text = await response.text();
            if (!text) return null;
            return JSON.parse(text);
        }
        catch (err) {
            console.warn('Failed to parse JSON response', err);
            return null;
        }
    }

    const getddlPageURLMaster = async () => {
        try {
            const response = await fetch(APIUrl.PageURLMaster + 'GetAllPageURLMaster', {
                method: "Post",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify()
            });

            const result = await parseJSON(response);

            if (result.Message == "Success") {
                setddlPageURLMaster(result.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getAllFAQs = async () => {
        try {
            const response = await fetch(APIUrl.FAQ + 'GetAllFAQ', {
                method: 'Post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify()
            });

            const result = await parseJSON(response);

            if (result?.Message === 'Success' && Array.isArray(result.data)) {
                const selectedURLId = Number(searchParams.get('id') || 0);
                const filteredDataByURLId = selectedURLId
                    ? result.data.filter((x) => Number(x.URLId) === selectedURLId)
                    : result.data;
                setlstFAQ(filteredDataByURLId);
                setfilterFAQ(filteredDataByURLId);
                return;
            }

            setlstFAQ([]);
            setfilterFAQ([]);
        }
        catch (error) {
            console.log(error);
            setlstFAQ([]);
            setfilterFAQ([]);
        }
    }

    async function activateDeactiveFAQ(Id, Value) {
        try {
            const data = { Value };
            const response = await fetch(APIUrl.FAQ + 'ActivateDeactivateFAQ/' + Id, {
                method: 'Post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify(data)
            });

            const result = await parseJSON(response);
            if (result) {
                await getAllFAQs();
                Value === 'activate'
                    ? enqueueSnackbar('Successfully Activated', { variant: 'success' })
                    : enqueueSnackbar('Successfully Deactivated', { variant: 'warning' });
            }
        }
        catch (error) {
            console.log(error);
            enqueueSnackbar('Failed to update FAQ status.', { variant: 'error' });
        }
    }

    function handleEditFAQ(row, FAQId) {
        if (!row?.URLId) {
            enqueueSnackbar('URLId not found for selected FAQ.', { variant: 'warning' });
            return;
        }

        setFlagAddFAQ(true);
        handleDDLChange(row.URLId, "onedit", FAQId);
        setEdit(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const handleDDLChange = (id, mode, FAQId) => {
        debugger;
        const filterPageURLMaster = ddlPageURLMaster.find(x => x.URLId == id);
        if (filterPageURLMaster) {
            setState(filterPageURLMaster.State);
            setCity(filterPageURLMaster.City);
            setPageURL(filterPageURLMaster.PageURL);
            setPropertyTypeName(filterPageURLMaster.PropertyTypeName);
            setURLId(filterPageURLMaster.URLId);
            if (mode == "onedit") {
                const filterFAQ = lstFAQ.find(x => x.FAQId == FAQId);
                if (filterFAQ) {
                    setFAQId(filterFAQ.FAQId);
                    setTitle(filterFAQ.Title);
                    setSequence(filterFAQ.Sequence || '');
                    setDescription(filterFAQ.Description);
                    setImagePath(APIUrl.BaseUrl + filterFAQ.ImagePath);
                    setImageAltText(filterFAQ.ImageAltText);
                    setImageTitle(filterFAQ.ImageTitle);
                    setImageDescription(filterFAQ.ImageDescription);
                    setImageCreatedBy(filterFAQ.ImageCreatedBy);
                    setYoutubeVideoURL(filterFAQ.YoutubeVideoURL);
                    setIsActive(filterFAQ.IsActive ?? true);
                    //setIsHadImage(false);
                    setFlagAddFAQ(true);
                }
                else {
                    setFAQId(0);
                    setTitle("");
                    setSequence("");
                    setDescription("");
                    setImagePath("");
                    setImageAltText("");
                    setImageTitle("");
                    setImageDescription("");
                    setImageCreatedBy("");
                    setYoutubeVideoURL("");
                    setIsActive(true);
                    setIsHadImage(false);
                    setFlagAddFAQ(false);
                }
            }
            // else {
            //     fnGetMyFAQByURLId(filterPageURLMaster.URLId);
            // }

        }
        else {
            setState("");
            setCity("");
            setPageURL("");
            setPropertyTypeName("");
            setURLId(0);

        }

        if (id == 0 || id == "0") {
            resetForm();
        }
    }

    const fnGetMyFAQByURLId = async (id) => {
        try {
            const response = await fetch(APIUrl.FAQ + 'GetFAQByURLId/' + id, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                }
            });

            const result = await parseJSON(response);
            if (result.Message == "Success" && result.data) {
                const detailData = result.data;
                setFAQId(detailData.FAQId);
                setTitle(detailData.Title);
                setSequence(detailData.Sequence || '');
                setDescription(detailData.Description);
                setImagePath(APIUrl.BaseUrl + detailData.ImagePath);
                setImageAltText(detailData.ImageAltText);
                setImageTitle(detailData.ImageTitle);
                setImageDescription(detailData.ImageDescription);
                setImageCreatedBy(detailData.ImageCreatedBy);
                setYoutubeVideoURL(detailData.YoutubeVideoURL);
                setIsActive(detailData.IsActive ?? true);
                setIsHadImage(false);
            }
            else {
                setFAQId(0);
                setTitle("");
                setSequence("");
                setDescription("");
                setImagePath("");
                setImageAltText("");
                setImageTitle("");
                setImageDescription("");
                setImageCreatedBy("");
                setYoutubeVideoURL("");
                setIsActive(true);
            }
        }
        catch (error) {
            console.log(error);
        }
    }


    const handleImageUploadClick = () => {
        imageInputRef.current?.click();
    };

    const handleImageChange = (event) => {
        const file = event.target.files?.[0];

        if (!file) {
            return;
        }

        const isValidType =
            ['image/jpeg', 'image/png'].includes(file.type) || ALLOWED_IMAGE_EXTENSIONS.test(file.name);

        if (!isValidType) {
            setImageError('Only JPG, JPEG, or PNG files are allowed.');
            event.target.value = '';
            return;
        }

        if (file.size > MAX_IMAGE_SIZE_BYTES) {
            setImageError('File size must be less than or equal to 1.5 MB.');
            event.target.value = '';
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            setImageFile(file);
            setImagePath(typeof reader.result === 'string' ? reader.result : '');
            setImageError('');
            event.target.value = '';
            setIsHadImage(true);
        };
        reader.readAsDataURL(file);
    };

    const resetForm = () => {
        setFAQId(0);
        // setURLId(0);
        setTitle('');
        setSequence('');
        setDescription('');
        setImagePath('');
        setImageFile(null);
        setImageAltText('');
        setImageTitle('');
        setImageDescription('');
        setImageCreatedBy('');
        setYoutubeVideoURL('');
        setIsActive(true);
        // setState('');
        // setCity('');
        // setPropertyTypeName('');
        // setPageURL('');
        setImageError('');
        if (imageInputRef.current) {
            imageInputRef.current.value = '';
        }
        setEdit(false);
        setIsHadImage(false);
        setFlagAddFAQ(false);
    };

    const validateAndSubmit = async () => {
        const validations = [
            { isInvalid: !Token, message: 'Please login first.' },
            { isInvalid: !URLId, message: 'Please Select Page URL.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !State.trim(), message: 'State is required.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !City.trim(), message: 'City is required.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !PropertyTypeName.trim(), message: 'Property Type is required.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !PageURL.trim(), message: 'Master Page URL is required.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !Title.trim(), message: 'Title is required.', focus: () => TitleRef.current?.focus() },
            { isInvalid: !Sequence.trim(), message: 'Sequence is required.', focus: () => SequenceRef.current?.focus() },
            { isInvalid: !getPlainTextFromHtml(Description), message: 'Description is required.', focus: () => descriptionEditorRef.current?.focus() },
            { isInvalid: !!ImageError, message: ImageError, focus: () => imageUploadButtonRef.current?.focus() },

            // { isInvalid: !ImageFile && !IsHadImage, message: 'Please upload image.', focus: () => imageUploadButtonRef.current?.focus() },
            { isInvalid: !ImageAltText.trim(), message: 'Image Alt is required.', focus: () => ImageAltTextRef.current?.focus() },
            { isInvalid: !ImageTitle.trim(), message: 'Image Title is required.', focus: () => ImageTitleRef.current?.focus() },
            { isInvalid: !ImageDescription.trim(), message: 'Image Description is required.', focus: () => ImageDescriptionRef.current?.focus() },
            { isInvalid: !ImageCreatedBy.trim(), message: 'Written By is required.', focus: () => ImageCreatedByRef.current?.focus() },
            { isInvalid: !YoutubeVideoURL.trim(), message: 'Youtube Video URL is required.', focus: () => YoutubeVideoURLRef.current?.focus() }
        ];

        const failedValidation = validations.find((item) => item.isInvalid);
        if (failedValidation) {
            enqueueSnackbar(failedValidation.message, { variant: 'warning' });
            failedValidation.focus?.();
            return;
        }

        try {
            const data = {
                FAQId,
                URLId,
                Title: Title.trim(),
                Sequence: Sequence.trim(),
                Description,
                ImagePath: '',
                ImageAltText: ImageAltText.trim(),
                ImageTitle: ImageTitle.trim(),
                ImageDescription: ImageDescription.trim(),
                ImageCreatedBy: ImageCreatedBy.trim(),
                YoutubeVideoURL: YoutubeVideoURL.trim(),
                IsActive,
                CreatedBy
            };

            const formData = new FormData();
            formData.append('faqJson', JSON.stringify(data));
            IsHadImage && formData.append('photo', ImageFile);


            const response = await fetch(APIUrl.FAQ + 'InsertFAQ', {
                method: 'Post',
                headers: {
                    'Authorization': `Bearer ${Token}`
                },
                body: formData
            });

            const result = await parseJSON(response);

            if (result?.Message === 'Success') {
                enqueueSnackbar(result?.Message || 'Successfully Added', { variant: 'success' });
                getAllFAQs();
                resetForm();
                return;
            }

            enqueueSnackbar(result?.Message || 'Failed to save FAQ.', { variant: 'error' });
        }
        catch (error) {
            console.log(error);
            enqueueSnackbar(error?.message || 'Error while saving FAQ.', { variant: 'error' });
        }
    };

    const validateAndUpdateFAQ = async () => {
        const validations = [
            { isInvalid: !Token, message: 'Please login first.' },
            { isInvalid: !URLId, message: 'Please Select Page URL.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !State.trim(), message: 'State is required.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !City.trim(), message: 'City is required.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !PropertyTypeName.trim(), message: 'Property Type is required.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !PageURL.trim(), message: 'Master Page URL is required.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !Title.trim(), message: 'Title is required.', focus: () => TitleRef.current?.focus() },
            { isInvalid: !Sequence.trim(), message: 'Sequence is required.', focus: () => SequenceRef.current?.focus() },
            { isInvalid: !getPlainTextFromHtml(Description), message: 'Description is required.', focus: () => descriptionEditorRef.current?.focus() },
            { isInvalid: !!ImageError, message: ImageError, focus: () => imageUploadButtonRef.current?.focus() },

            // { isInvalid: !ImageFile && !IsHadImage, message: 'Please upload image.', focus: () => imageUploadButtonRef.current?.focus() },
            { isInvalid: !ImageAltText.trim(), message: 'Image Alt is required.', focus: () => ImageAltTextRef.current?.focus() },
            { isInvalid: !ImageTitle.trim(), message: 'Image Title is required.', focus: () => ImageTitleRef.current?.focus() },
            { isInvalid: !ImageDescription.trim(), message: 'Image Description is required.', focus: () => ImageDescriptionRef.current?.focus() },
            { isInvalid: !ImageCreatedBy.trim(), message: 'Written By is required.', focus: () => ImageCreatedByRef.current?.focus() },
            { isInvalid: !YoutubeVideoURL.trim(), message: 'Youtube Video URL is required.', focus: () => YoutubeVideoURLRef.current?.focus() }
        ];

        const failedValidation = validations.find((item) => item.isInvalid);
        if (failedValidation) {
            enqueueSnackbar(failedValidation.message, { variant: 'warning' });
            failedValidation.focus?.();
            return;
        }

        try {
            const data = {
                FAQId,
                URLId,
                Title: Title.trim(),
                Sequence: Sequence.trim(),
                Description,
                ImagePath: '',
                ImageAltText: ImageAltText.trim(),
                ImageTitle: ImageTitle.trim(),
                ImageDescription: ImageDescription.trim(),
                ImageCreatedBy: ImageCreatedBy.trim(),
                YoutubeVideoURL: YoutubeVideoURL.trim(),
                IsActive,
                CreatedBy
            };

            const formData = new FormData();
            formData.append('faqJson', JSON.stringify(data));
            IsHadImage && formData.append('photo', ImageFile);

            const response = await fetch(APIUrl.FAQ + 'UpdateFAQ/' + FAQId, {
                method: 'Post',
                headers: {
                    'Authorization': `Bearer ${Token}`
                },
                body: formData
            });

            const result = await parseJSON(response);

            if (result?.Message === 'Success') {
                enqueueSnackbar(result?.Message || 'Successfully Updated', { variant: 'success' });
                getAllFAQs();
                resetForm();
                return;
            }

            enqueueSnackbar(result?.Message || 'Failed to update FAQ.', { variant: 'error' });
        }
        catch (error) {
            console.log(error);
            enqueueSnackbar(error?.message || 'Error while updating FAQ.', { variant: 'error' });
        }
    };



    return (
        <Layout>
            <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8 bg-slate-50">
                <div className="mx-auto w-full max-w-[1500px] rounded-xl border border-slate-200 bg-white shadow-sm">
                    <div className="flex flex-col gap-3 border-b border-slate-200 p-4 sm:p-5 md:flex-row md:items-center md:justify-between">
                        <div>
                            <h1 className="text-xl font-semibold text-slate-900">FAQ : {ddlPageURLMaster.find(x => x.URLId === URLId)?.PageURL}</h1>
                            <p className="mt-1 text-sm text-slate-600">{ }</p>
                        </div>
                        <div>
                            {
                                !flagAddFAQ && (
                                    <button
                                        type="button"
                                        onClick={() => setFlagAddFAQ(true)}
                                        disabled={flagAddFAQ}
                                        className="mr-2 rounded-md bg-indigo-600 px-4 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2"
                                    >
                                        Add FAQ
                                    </button>
                                )
                            }
                            <button
                                type="button"
                                onClick={() => window.location.assign('/pageurlmaster')}
                                className="rounded-md bg-indigo-600 px-4 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2"
                            >
                                Back to Page URL Master
                            </button>
                        </div>
                    </div>
                    {
                        flagAddFAQ && (<>
                            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 border-b border-slate-200 p-4 sm:p-5">
                                <select
                                    ref={pageURLSelectRef}
                                    value={URLId}
                                    onChange={(e) => handleDDLChange(e.target.value)}
                                    disabled
                                    className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100">
                                    <option value={0}>Select Page URL</option>
                                    {
                                        ddlPageURLMaster.map((item) => (
                                            <option key={item.URLId} value={item.URLId}>{item.PageURL}</option>
                                        ))
                                    }
                                </select>
                            </div>

                            <div className="space-y-4 p-4 sm:p-5">
                                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                            <div>
                                <label className='mb-1.5 block text-xs font-semibold text-slate-600'>State</label>
                                <input
                                    type='text'
                                    className='w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                    value={State}
                                    disabled={true}
                                />
                            </div>
                            <div>
                                <label className='mb-1.5 block text-xs font-semibold text-slate-600'>City</label>
                                <input
                                    type='text'
                                    className='w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                    value={City}
                                    disabled={true}
                                />
                            </div>
                            <div>
                                <label className='mb-1.5 block text-xs font-semibold text-slate-600'>Property Type</label>
                                <input
                                    type='text'
                                    className='w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                    value={PropertyTypeName}
                                    disabled={true}
                                />
                            </div>
                            <div>
                                <label className='mb-1.5 block text-xs font-semibold text-slate-600'>Master Page URL</label>
                                <input
                                    type='text'
                                    className='w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                    value={PageURL}
                                    disabled={true}
                                />
                            </div>
                            </div>
                            <div className="grid grid-cols-1 gap-4 md:grid-cols-12">
                            <div className="md:col-span-10">
                                <label className='mb-1.5 block text-xs font-semibold text-slate-600'>Title</label>
                                <input
                                    ref={TitleRef}
                                    type='text'
                                    className='w-full rounded-md border border-slate-300 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                    value={Title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    minLength={150}
                                />
                            </div>
                            <div className="md:col-span-2">
                                <label className='mb-1.5 block text-xs font-semibold text-slate-600'>Sequence</label>
                                <input
                                    ref={SequenceRef}
                                    type='text'
                                    className='w-full rounded-md border border-slate-300 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                    value={Sequence}
                                    onChange={(e) => setSequence(e.target.value)}
                                    onKeyDown={handleKeyPress}
                                    maxLength={2}
                                />
                            </div>
                                </div>

                                <div>
                            <label className="mb-1.5 block text-xs font-semibold text-slate-600">Description</label>
                            <HtmlEditor
                                value={Description}
                                onChange={setDescription}
                                onReady={(editor) => {
                                    descriptionEditorRef.current = editor;
                                }}
                                placeholder="Write your content here..."
                            />
                            </div>

                            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                            <div>
                                <label className="mb-1.5 block text-xs font-semibold text-slate-600">Upload Image</label>
                                <input
                                    ref={imageInputRef}
                                    type="file"
                                    accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                    className="hidden"
                                    onChange={handleImageChange}
                                />
                                <div className="flex w-full max-w-xs items-center gap-3 rounded-lg border border-slate-300 bg-slate-50 p-3">
                                    <div className="h-14 w-14 overflow-hidden rounded border border-slate-200 bg-white">
                                        <img
                                            src={ImagePath || DUMMY_IMAGE_PREVIEW}
                                            alt="Preview"
                                            className="h-full w-full object-cover"
                                        />
                                    </div>
                                    <button
                                        ref={imageUploadButtonRef}
                                        type="button"
                                        onClick={handleImageUploadClick}
                                        className="rounded-md border border-slate-300 bg-white px-4 py-2 text-xs font-semibold text-slate-700 transition hover:border-indigo-300 hover:text-indigo-600"
                                    >
                                        Upload
                                    </button>
                                </div>
                                <p className="mt-1 text-[11px] text-slate-500">Allowed: JPG, JPEG, PNG | Max size: 1.5 MB</p>
                                {ImageError && <p className="mt-1 text-xs font-medium text-red-600">{ImageError}</p>}
                            </div>
                            <div>
                                <label className="mb-1.5 block text-xs font-semibold text-slate-600">Image Alt</label>
                                <input
                                    ref={ImageAltTextRef}
                                    type="text"
                                    value={ImageAltText}
                                    onChange={(e) => setImageAltText(e.target.value)}
                                    className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                                />
                            </div>
                            <div>
                                <label className="mb-1.5 block text-xs font-semibold text-slate-600">Image Title</label>
                                <input
                                    ref={ImageTitleRef}
                                    type="text"
                                    value={ImageTitle}
                                    onChange={(e) => setImageTitle(e.target.value)}
                                    className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                                />
                            </div>
                            <div>
                                <label className="mb-1.5 block text-xs font-semibold text-slate-600">Image Description</label>
                                <input
                                    ref={ImageDescriptionRef}
                                    type="text"
                                    value={ImageDescription}
                                    onChange={(e) => setImageDescription(e.target.value)}
                                    className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                                />
                            </div>
                            <div>
                                <label className="mb-1.5 block text-xs font-semibold text-slate-600">Written By</label>
                                <input
                                    ref={ImageCreatedByRef}
                                    type="text"
                                    value={ImageCreatedBy}
                                    onChange={(e) => setImageCreatedBy(e.target.value)}
                                    className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                                />
                            </div>
                                </div>

                                <div>
                            <label className="mb-1.5 block text-xs font-semibold text-slate-600">Youtube Video URL</label>
                            <input
                                ref={YoutubeVideoURLRef}
                                type="text"
                                value={YoutubeVideoURL}
                                onChange={(e) => setYoutubeVideoURL(e.target.value)}
                                placeholder="video url"
                                className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                            />
                                </div>

                                <div className="flex flex-wrap items-center gap-2 pt-2">
                                    {
                                        !edit ? <button
                                            type="button"
                                            onClick={validateAndSubmit}
                                            className="rounded-md bg-blue-600 px-4 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-blue-700"
                                        >
                                            Save
                                        </button> :
                                            <button
                                                type="button"
                                                onClick={validateAndUpdateFAQ}
                                                className="rounded-md bg-blue-600 px-4 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-blue-700"
                                            >
                                                Update
                                            </button>
                                    }
                                    <button
                                        type="button"
                                        onClick={() => resetForm()}
                                        className="rounded-md bg-blue-600 px-4 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-blue-700"
                                    >
                                        Reset
                                    </button>
                                </div>
                            </div>
                        </>
                        )
                    }
                </div>

                <div className="mt-6 rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden">
                    <div className="overflow-x-auto">
                        <DataTable
                            title="Manage FAQ"
                            columns={coloumn}
                            data={filterFAQ}
                            pagination
                            fixedHeader
                            fixedHeaderScrollHeight="500px"
                            highlightOnHover
                            subHeader
                            subHeaderAlign="right"
                            subHeaderComponent={
                                <input
                                    type="text"
                                    placeholder="Search FAQ"
                                    className="w-full sm:w-72 rounded-lg border border-slate-300 px-4 py-2 text-sm focus:border-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-100"
                                    value={search}
                                    onChange={(e) => setsearch(e.target.value)}
                                />
                            }
                        />
                    </div>
                </div>

            </main>
        </Layout>
    );
}


function HtmlEditor({ value, onChange, placeholder = '', onReady }) {
    const editorImageInputRef = useRef(null);
    const { quill, quillRef } = useQuill({
        theme: 'snow',
        modules: quillModules,
        formats: quillFormats,
        placeholder
    });

    useEffect(() => {
        if (quill && onReady) {
            onReady(quill);
        }
    }, [quill, onReady]);

    useEffect(() => {
        if (!quill) {
            return;
        }

        const toolbar = quill.getModule('toolbar');
        if (!toolbar) {
            return;
        }

        const handleInsertLink = () => {
            const url = window.prompt('Enter link URL');
            if (!url) {
                return;
            }

            const range = quill.getSelection(true);
            const index = range ? range.index : quill.getLength();
            quill.insertText(index, url, 'link', url, 'user');
            quill.setSelection(index + url.length, 0, 'user');
        };

        const handleInsertImage = () => {
            editorImageInputRef.current?.click();
        };

        const handleInsertVideo = () => {
            const videoUrl = window.prompt('Enter YouTube/Vimeo embed URL');
            if (!videoUrl) {
                return;
            }

            const range = quill.getSelection(true);
            const index = range ? range.index : quill.getLength();
            quill.insertEmbed(index, 'video', videoUrl, 'user');
            quill.setSelection(index + 1, 0, 'user');
        };

        toolbar.addHandler('link', handleInsertLink);
        toolbar.addHandler('image', handleInsertImage);
        toolbar.addHandler('video', handleInsertVideo);
    }, [quill]);

    const handleEditorImageChange = (event) => {
        const file = event.target.files?.[0];
        if (!file || !quill) {
            return;
        }

        const isValidType = ['image/jpeg', 'image/png'].includes(file.type) || ALLOWED_IMAGE_EXTENSIONS.test(file.name);
        if (!isValidType) {
            window.alert('Only JPG, JPEG, or PNG files are allowed in the editor.');
            event.target.value = '';
            return;
        }

        if (file.size > MAX_EDITOR_IMAGE_SIZE_BYTES) {
            window.alert('Editor image size must be less than or equal to 2 MB.');
            event.target.value = '';
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            const base64 = typeof reader.result === 'string' ? reader.result : '';
            if (!base64) {
                event.target.value = '';
                return;
            }

            const range = quill.getSelection(true);
            const index = range ? range.index : quill.getLength();
            quill.insertEmbed(index, 'image', base64, 'user');
            quill.setSelection(index + 1, 0, 'user');
            event.target.value = '';
        };

        reader.readAsDataURL(file);
    };

    useEffect(() => {
        if (!quill) {
            return;
        }

        const nextValue = value || '';
        const currentValue = quill.root.innerHTML === '<p><br></p>' ? '' : quill.root.innerHTML;

        if (currentValue !== nextValue) {
            if (nextValue) {
                quill.clipboard.dangerouslyPasteHTML(nextValue);
            }
            else {
                quill.setText('');
            }
        }
    }, [quill, value]);

    useEffect(() => {
        if (!quill) {
            return;
        }

        const handleChange = () => {
            const html = quill.root.innerHTML;
            onChange(html === '<p><br></p>' ? '' : html);
        };

        quill.on('text-change', handleChange);

        return () => {
            quill.off('text-change', handleChange);
        };
    }, [quill, onChange]);

    return (
        <div className="overflow-hidden rounded-md border border-slate-300 bg-white [&_.ql-container]:min-h-[220px] [&_.ql-container]:border-0 [&_.ql-editor]:min-h-[220px] [&_.ql-editor]:text-sm [&_.ql-toolbar]:border-x-0 [&_.ql-toolbar]:border-t-0">
            <input
                ref={editorImageInputRef}
                type="file"
                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                className="hidden"
                onChange={handleEditorImageChange}
            />
            <div ref={quillRef} />
        </div>
    );
}

export default FAQ;